import { render, staticRenderFns } from "./x-history-queries.component.vue?vue&type=template&id=39fb26f4&scoped=true"
import script from "./x-history-queries.component.vue?vue&type=script&lang=ts"
export * from "./x-history-queries.component.vue?vue&type=script&lang=ts"
import style0 from "./x-history-queries.component.vue?vue&type=style&index=0&id=39fb26f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fb26f4",
  null
  
)

export default component.exports